const PAYMENT_MAIN_MAX_WIDTH = 704;
const PAYMENT_SIDEBAR_MAX_WIDTH = 480;
const CHECKOUT_GRID_GAP = 16;

export const PAYMENT_PAGE_LAYOUT = {
  contentMaxWidth:
    PAYMENT_MAIN_MAX_WIDTH + CHECKOUT_GRID_GAP + PAYMENT_SIDEBAR_MAX_WIDTH,
  mainMaxWidth: PAYMENT_MAIN_MAX_WIDTH,
  mainPaddingInlineSpacing: 5,
  sidebarMaxWidth: PAYMENT_SIDEBAR_MAX_WIDTH,
  sidebarPaddingInlineSpacing: 6,
};
